// import React, { useState } from "react";
// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import axiosInstance from "../../../../../../axios";
// import axios from "axios";
// import { toBinary } from "../../../../../../_helpers";
// import { getS3URL } from "../../../../../../_helpers";
// import { EditorState, convertToRaw, ContentState } from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";

// const TextEditor = ({ formState, handleEditorStateChange, history }) => {
//   const [progressCount, setProgressCount] = useState(0);

//   const [editorState, setEditorState] = useState(() => {
//     if (formState) {
//       const blocksFromHtml = htmlToDraft(formState);
//       const { contentBlocks, entityMap } = blocksFromHtml;
//       const contentState = ContentState.createFromBlockArray(
//         contentBlocks,
//         entityMap
//       );
//       return EditorState.createWithContent(contentState);
//     } else {
//       return EditorState.createEmpty();
//     }
//   });
// console.log("editorState",editorState);
//   const onEditorStateChange = (state) => {
//     setEditorState(state);
//     convertContentToHTML();
//   };

//   const convertContentToHTML = () => {
//     let currentContentAsHTML = draftToHtml(
//       convertToRaw(editorState.getCurrentContent())
//     );
//     console.log("currentContentAsHTML",currentContentAsHTML);
//     handleEditorStateChange(currentContentAsHTML);
//   };

//   const uploadNewFile = async (file, courseId, storageType) => {
//     const data = await startMultipart(file, courseId, storageType)
//       .then(getSignedURL)
//       .then(uploadContent)
//       .then(completeMutipart)
//       .then((data) => {
//         return data;
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//     return data;
//   };

//   const getSignedURL = async ({ key, uploadId, storageType, file }) => {
//     return axiosInstance
//       .get(`signed-url?uploadId=${uploadId}&partNumber=1&key=${key}`)
//       .then(({ data }) => {
//         return {
//           key: key,
//           uploadId: uploadId,
//           signedURL: data.data,
//           storageType: storageType,
//           file: file,
//         };
//       })
//       .catch((error) => error);
//   };
//   const configOptions = {
//     headers: { "content-type": "multipart/form-data" },
//   };

//   const uploadContent = async ({
//     key,
//     uploadId,
//     signedURL,
//     storageType,
//     file,
//   }) => {
//     return toBinary(file).then((binaryFile) => {
//       return axios
//         .put(signedURL, binaryFile.blob, configOptions)
//         .then((response) => ({
//           key: key,
//           uploadId: uploadId,
//           eTag: response.headers.etag,
//           storageType: storageType,
//           file: file,
//         }));
//     });
//   };
//   const getCompleteMultipartRequestBody = ({
//     key,
//     uploadId,
//     eTag,
//     storageType,
//     duration,
//   }) => ({
//     uploadId: uploadId,
//     uploadedParts: [
//       {
//         PartNumber: 1,
//         ETag: `${eTag}`,
//       },
//     ],
//     key: key,
//     storageType: storageType,
//     duration: Math.round(duration),
//   });

//   const completeMutipart = async (response) => {
//     return axiosInstance
//       .post("complete/multipart", getCompleteMultipartRequestBody(response))
//       .then(() => response.key);
//   };

//   const getFileRequestBody = (file, courseId, storageType) => ({
//     fileName: file.name.substr(0, file.name.lastIndexOf(".")),
//     fileExt: file.name.substr(file.name.lastIndexOf(".") + 1),
//     courseId: courseId,
//     storageType: storageType,
//   });
//   const startMultipart = async (file, courseId, storageType) => {
//     return axiosInstance
//       .post("start/multipart", getFileRequestBody(file, courseId, storageType))
//       .then(({ data }) => {
//         return {
//           key: data.data.Key,
//           uploadId: data.data.UploadId,
//           storageType: storageType,
//           file: file,
//         };
//       })
//       .catch((error) => error);
//   };

//   const uploadCallback = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new window.FileReader();
//       reader.onloadend = async () => {
//         uploadNewFile(
//           file,
//           history?.location?.state?.courseId,
//           "CourseImages"
//         ).then((data) => {
//           resolve({ data: { link: getS3URL(data) } });
//         });
//       };
//       reader.readAsDataURL(file);
//     });
//   };

  
  
//   return (
//     <div className="texteditor-hero">
//       <Editor
//         editorState={editorState}
//         toolbarClassName="toolbarClassName"
//         wrapperClassName="wrapperClassName"
//         editorClassName="editorClassName"
//         onEditorStateChange={onEditorStateChange}
//         toolbar={{
//           inline: { inDropdown: true },
//           list: { inDropdown: true },
//           textAlign: { inDropdown: true },
//           link: { inDropdown: true },
//           history: { inDropdown: true },
//           image: {
//             options: [
//               "inline",
//               "fontSize",
//               "fontFamily",
//               "list",
//               "textAlign",
//               "colorPicker",
//               "link",
//               "image",
//             ],
//             link: {
//               defaultTargetOption: "_blank",
//               showOpenOptionOnHover: true,
//             },
//             uploadCallback: uploadCallback,
//             alt: { present: true, mandatory: false },
//             urlEnabled: true,
//             uploadEnabled: true,
//             alignmentEnabled: true,
//             defaultSize: {
//               height: "100%",
//               width: "100%",
//             },
//           },
//         }}
//         placeholder="write your description"
//       />
      
//     </div>
//   );
// };

// export default TextEditor;


import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles for the editor
import axiosInstance from "../../../../../../axios";
import axios from "axios";
import { toBinary } from "../../../../../../_helpers";
import { getS3URL } from "../../../../../../_helpers";

const TextEditor = ({ formState, handleEditorStateChange, history }) => {
  const [content, setContent] = useState(formState || "");

  const onEditorStateChange = (value) => {
    setContent(value);
    handleEditorStateChange(value); // Pass updated HTML to the parent
  };

  const uploadCallback = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        uploadNewFile(file, history?.location?.state?.courseId, "CourseImages")
          .then((data) => {
            resolve({ data: { link: getS3URL(data) } });
          })
          .catch((error) => reject(error));
      };
      reader.readAsDataURL(file);
    });
  };

  const uploadNewFile = async (file, courseId, storageType) => {
    try {
      const { key, uploadId } = await startMultipart(file, courseId, storageType);
      const { signedURL } = await getSignedURL({ key, uploadId });
      const { eTag } = await uploadContent({ signedURL, file });
      await completeMultipart({ key, uploadId, eTag });
      return key;
    } catch (error) {
      console.error("File upload failed:", error);
      return null;
    }
  };

  const startMultipart = async (file, courseId, storageType) => {
    try {
      const { data } = await axiosInstance.post("start/multipart", {
        fileName: file.name.split(".")[0],
        fileExt: file.name.split(".").pop(),
        courseId,
        storageType,
      });
      return { key: data.data.Key, uploadId: data.data.UploadId };
    } catch (error) {
      console.error("Error starting multipart upload:", error);
      throw error;
    }
  };

  const getSignedURL = async ({ key, uploadId }) => {
    try {
      const { data } = await axiosInstance.get(`signed-url?uploadId=${uploadId}&partNumber=1&key=${key}`);
      return { signedURL: data.data };
    } catch (error) {
      console.error("Error getting signed URL:", error);
      throw error;
    }
  };

  const uploadContent = async ({ signedURL, file }) => {
    try {
      const binaryFile = await toBinary(file);
      const response = await axios.put(signedURL, binaryFile.blob, {
        headers: { "content-type": "multipart/form-data" },
      });
      return { eTag: response.headers.etag };
    } catch (error) {
      throw error;
    }
  };

  const completeMultipart = async ({ key, uploadId, eTag }) => {
    try {
      await axiosInstance.post("complete/multipart", {
        uploadId,
        uploadedParts: [{ PartNumber: 1, ETag: eTag }],
        key,
        storageType: "CourseImages",
      });
    } catch (error) {
      console.error("Error completing multipart upload:", error);
      throw error;
    }
  };

  return (
    <div className="texteditor-hero">
      <ReactQuill
        value={content}
        onChange={onEditorStateChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
          ],
        }}
        placeholder="Write your description..."
      />
    </div>
  );
};

export default TextEditor;

